import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { ProductBrowser } from "../components/ProductBrowser";

export default function ProductsPage() {
  return (
    <div className="App grain bg-offwhite min-h-screen" data-testid="products-page">
      <Navbar />
      <main className="w-full max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 pt-32 md:pt-40 pb-24">
        <header className="mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-military font-semibold mb-4">Catálogo completo</p>
          <h1 className="font-serif text-4xl md:text-6xl text-military-dark tracking-tight">
            Todos os <span className="italic font-light text-military">produtos.</span>
          </h1>
        </header>
        <ProductBrowser />
      </main>
      <Footer />
    </div>
  );
}
